import React, { useEffect } from 'react'
import cx from 'classnames'
import { useIntl } from 'intl'
import links from 'links'
import { usePathname } from 'router'
import { track } from 'analytics'

import { useInAppMessages } from 'modules/inAppMessages'
import { Icon } from 'components/dataDisplay'
import { Href } from 'components/navigation'

import messages from './messages'

import s from './InAppMessagesCounter.scss'


type InAppMessagesCounterProps = {
  className?: string
}

const InAppMessagesCounter: React.FunctionComponent<InAppMessagesCounterProps> = (props) => {
  const { className } = props
  const { unreadMessagesCount, inAppMessages, isFetching } = useInAppMessages()

  const intl = useIntl()
  const label = intl.formatMessage(messages.label)

  const pathname = usePathname()

  useEffect(() => {
    if (isFetching) {
      return
    }

    track('Notifications icon display', {
      numberOfMessages: inAppMessages.length,
      numberOfUnreadMessages: unreadMessagesCount,
    })

    // pathname is added to deps to track event on page changes
  }, [ pathname, isFetching, unreadMessagesCount, inAppMessages ])

  return (
    <Href
      className={cx(className, 'relative cursor-pointer text-white')}
      to={links.inAppMessagesCenter}
      aria-label={label}
      onClick={() => {
        track('Notifications icon click')
      }}
    >
      <Icon
        name="32/bell"
      />
      {
        unreadMessagesCount > 0 && (
          <span
            className={cx(s.count, 'absolute right-0 top-0 flex h-s16 w-s16 items-center justify-center rounded-full bg-white text-eye3 text-black')}
            key={pathname} // Restart animation on page change
          >
            {unreadMessagesCount}
          </span>
        )
      }
    </Href>
  )
}


export default InAppMessagesCounter
